import { useAuth0 } from '@auth0/auth0-react'
// import { Typography } from '@material-ui/core'
import { Navigate } from 'react-router-dom'
import Spinning from './Spinner/Spinning'

const HandleAuthentication = () => {
  const auth0 = useAuth0()
  console.info('HandleAuthentication component')

  if (auth0.isLoading) {
    return <Spinning />
  }

  if (auth0.isAuthenticated) {
    // console.log('location state', location.state)
    return <Spinning />
  }

  // return <Typography>handle authentication</Typography>
  return <Navigate to="/app" />
}

export default HandleAuthentication
